/* Healpurea — Cart interactions */
(() => {
  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];

  const cartBtns      = $$('[data-open-cart]');
  const cartDrawer    = $('#hpCartDrawer');
  const cartClose     = $('#hpCartClose');
  const cartScrim     = $('#hpCartScrim');
  const cartItems     = $('#hpCartItems');
  const cartCount     = $('#hpCartCount');
  const cartCountBadge = $('#hpCartCountBadge');
  const cartCongrats  = $('#hpCartCongrats');
  const cartSavingsAmt = $('#hpCartSavingsAmt');
  const cartReserved  = $('#hpCartReserved');
  const cartTimerEl   = $('#hpCartTimer');
  const cartFoot      = $('#hpCartFoot');
  const cartShipProgress = $('#hpCartShippingProgress');
  const cartItemCount = $('#hpCartItemCount');
  const cartTotalCompare = $('#hpCartTotalCompare');
  const cartTotalPrice  = $('#hpCartTotalPrice');
  const shippingToggle  = $('#hpShippingProtection');

  const money = (cents) => `$${(cents / 100).toFixed(2)}`;

  /* ---- Gift bundle config: matches the free-gift offer on the PDP.
     Each gift is a real $0.00 Shopify product/variant (created in Admin) so it
     actually rides along into the real cart and checkout, not just the drawer. */
  const giftAssets = window.hpCartGiftAssets || {};
  const GIFTS = [
    { variantId: '47808866386051', title: 'The U-Shape Half-Moon Pillow', compare: 3999, image: giftAssets.halfmoon || '' },
    { variantId: '47808866549891', title: '90-Day Money Back Guarantee',  compare: 10999, image: giftAssets.guarantee || '' }
  ];
  const GIFT_VARIANT_IDS = GIFTS.map(g => g.variantId);

  /* Real bundle-variant pricing/pillow-count lookup.
     Shopify's cart.js line items don't expose compare_at_price, so each bundle
     variant's real compare-at (set in Admin) and pillow count are hardcoded here,
     keyed by the real variant IDs created for the 1/2/3-Pack bundle options. */
  const BUNDLE_VARIANTS = {
    '47779529228419': { compareAtCents: 24999, priceCents: 14999, pillows: 1 }, // 1-Pack — $149.99 / compare $249.99
    '47779529261187': { compareAtCents: 49998, priceCents: 25999, pillows: 2 }, // 2-Pack — $259.99 / compare $499.98
    '47779529293955': { compareAtCents: 74997, priceCents: 35999, pillows: 3 }  // 3-Pack — $359.99 / compare $749.97
  };
  /* Ascending by pillow count, so +/- can step between tiers (1-Pack <-> 2-Pack <-> 3-Pack)
     instead of just adding/removing raw quantity of the same variant. */
  const TIER_ORDER = Object.keys(BUNDLE_VARIANTS).sort((a, b) => BUNDLE_VARIANTS[a].pillows - BUNDLE_VARIANTS[b].pillows);

  const openCart  = () => { cartDrawer?.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
  const closeCart = () => { cartDrawer?.classList.remove('is-open'); document.body.style.overflow = ''; };
  cartBtns.forEach(btn => btn.addEventListener('click', (e) => { e.preventDefault(); fetchCart().then(openCart); }));
  cartClose?.addEventListener('click', closeCart);
  cartScrim?.addEventListener('click', closeCart);

  const fetchCart = () => fetch('/cart.js').then(r => r.json()).then(renderCart);

  const addToCart = (variantId, qty) => {
    const info = BUNDLE_VARIANTS[String(variantId)] || { pillows: 1 };
    const pillowCount = info.pillows * qty;
    const pillowLabel = `${pillowCount} PILLOW${pillowCount > 1 ? 'S' : ''}`;

    return fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const presentIds = new Set(cart.items.map(it => String(it.variant_id)));
        /* Shopify's real cart (and therefore checkout) ends up with lines in
           the REVERSE of the order they're listed in a single /cart/add.js
           call — verified directly against this store. Building the array
           back-to-front (last gift first, pillow last) makes the real
           checkout order come out Pillow → Half-Moon → 90-Day as intended.
           The "N PILLOWS" property recalculates every time an item is added,
           so it always matches the real quantity in THAT cart — unlike the
           discount's own auto-shown name, which is fixed text set in Admin. */
        const items = [];
        [...GIFTS].reverse().forEach(g => {
          if (!presentIds.has(g.variantId)) {
            items.push({ id: g.variantId, quantity: 1, properties: { ' ': pillowLabel } });
          }
        });
        items.push({ id: variantId, quantity: qty });
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
      })
      .then(r => r.json())
      .then(data => {
        if (data.status) { throw new Error(data.description || 'Could not add to cart'); }
        return fetchCart();
      })
      .then(openCart);
  };

  /* Strip the two gift lines out of the real cart — used when the pillow line
     is fully removed, since the gift-with-purchase offer no longer applies. */
  const removeGiftLines = (cart) => {
    const giftLines = cart.items.filter(it => GIFT_VARIANT_IDS.includes(String(it.variant_id)));
    if (!giftLines.length) return Promise.resolve();
    return Promise.all(giftLines.map(it => fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: it.key, quantity: 0 })
    })));
  };

  const removePillowAndGifts = (key) => {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(r => r.json())
      .then(removeGiftLines)
      .then(fetchCart);
  };

  const updateQty = (lineKey, qty) => {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: qty })
    }).then(r => r.json()).then(renderCart);
  };

  /* Step a bundle line up/down to a different pack tier: remove the current
     line, then add the target tier's variant — so going from a 2-Pack down to
     a 1-Pack actually charges the 1-Pack price instead of just deleting a unit. */
  const switchVariant = (oldLineKey, newVariantId) => {
    const info = BUNDLE_VARIANTS[String(newVariantId)] || { pillows: 1 };
    const pillowLabel = `${info.pillows} PILLOW${info.pillows > 1 ? 'S' : ''}`;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: oldLineKey, quantity: 0 })
    })
      .then(() => fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: newVariantId, quantity: 1 }] })
      }))
      .then(() => fetch('/cart.js'))
      .then(r => r.json())
      .then(cart => {
        /* The gift lines' "N PILLOWS" property was set to the OLD tier's count
           when they were first added — refresh it to match the new tier. */
        const giftLines = cart.items.filter(it => GIFT_VARIANT_IDS.includes(String(it.variant_id)));
        return Promise.all(giftLines.map(it => fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: it.key, quantity: it.quantity, properties: { ' ': pillowLabel } })
        })));
      })
      .then(() => fetchCart());
  };

  /* ---- Reservation countdown: persists across drawer opens within the same session ---- */
  const RESERVE_MINUTES = 10;
  let reserveInterval = null;
  const startReserveTimer = () => {
    const key = 'hpCartReserveDeadline';
    let deadline = sessionStorage.getItem(key);
    if (!deadline || Date.now() > Number(deadline)) {
      deadline = Date.now() + RESERVE_MINUTES * 60 * 1000;
      sessionStorage.setItem(key, String(deadline));
    }
    clearInterval(reserveInterval);
    const tick = () => {
      const remaining = Math.max(0, Number(sessionStorage.getItem(key)) - Date.now());
      const mins = Math.floor(remaining / 60000);
      const secs = Math.floor((remaining % 60000) / 1000);
      if (cartTimerEl) cartTimerEl.textContent = `${mins}:${String(secs).padStart(2, '0')}`;
      if (remaining <= 0) clearInterval(reserveInterval);
    };
    tick();
    reserveInterval = setInterval(tick, 1000);
  };

  const renderCart = (cart) => {
    if (!cartItems) return;

    if (cart.items && cart.items.length > 0) {
      sessionStorage.setItem('hpHadRealItems', '1');
    }

    if (!cart.items || cart.items.length === 0) {
      /* Once the customer has had the pillow in cart this session, keep the
         free-gift items visible when it's removed — but at their real price,
         since the gift-with-purchase offer no longer applies. Pure display
         nudge: these were never real cart line items, so nothing here changes
         what checkout actually charges (still $0 either way). */
      const hadRealItems = sessionStorage.getItem('hpHadRealItems') === '1';
      const paidGiftLinesHtml = hadRealItems ? GIFTS.map(g => `
        <div class="hp-cart-line">
          <div class="hp-cart-line__img"><img src="${g.image}" alt="${g.title}"></div>
          <div class="hp-cart-line__body">
            <div class="hp-cart-line__top-row">
              <p class="hp-cart-line__name">${g.title}</p>
              <div class="hp-cart-line__price-col">
                <div class="hp-cart-line__price-row"><span class="hp-cart-line__price">${money(g.compare)}</span></div>
              </div>
            </div>
          </div>
        </div>`).join('') : '';

      cartItems.innerHTML = `
        <div class="hp-cart-empty">
          <p class="hp-cart-empty__title">Your cart is empty</p>
          <a href="/collections/all" class="hp-cart-empty__continue">Continue Shopping</a>
        </div>
        ${hadRealItems ? `<p class="hp-cart-empty-gifts-label">Add your pillow back to get these free again</p>${paidGiftLinesHtml}` : ''}
        <div class="hp-cart-empty-footer">
          <p class="hp-cart-empty__account">Have an account?</p>
          <p class="hp-cart-empty__login"><a href="/account/login">Log in</a> to check out faster.</p>
        </div>`;
      cartCount && (cartCount.textContent = '0', cartCount.hidden = true);
      cartCountBadge && (cartCountBadge.textContent = '0');
      cartCongrats && (cartCongrats.hidden = true);
      cartReserved && (cartReserved.hidden = true);
      cartShipProgress && (cartShipProgress.hidden = true);
      cartFoot && (cartFoot.hidden = true);
      clearInterval(reserveInterval);
      sessionStorage.removeItem('hpCartReserveDeadline');
      return;
    }

    /* Split the real cart into the pillow line(s) and the real gift lines —
       the gifts are now actual $0.00 products riding along in the cart, not
       just decoration, so they must not be double-counted as pillow lines. */
    const pillowItems = cart.items.filter(it => !GIFT_VARIANT_IDS.includes(String(it.variant_id)));
    const giftItemsInCart = cart.items.filter(it => GIFT_VARIANT_IDS.includes(String(it.variant_id)));

    /* Real product line items. Shopify's cart.js line items don't expose the
       variant's compare_at_price (verified: original_line_price always equals
       line_price with no discount app active), so compare-at + pillow count
       per bundle variant come from the BUNDLE_VARIANTS lookup above. */
    const bundleInfo = (it) => BUNDLE_VARIANTS[String(it.variant_id)] || { compareAtCents: Math.round((it.price || 0)), pillows: 1 };
    const totalPillows = pillowItems.reduce((sum, it) => sum + bundleInfo(it).pillows * it.quantity, 0);

    const realLinesHtml = pillowItems.map(it => {
      const info = bundleInfo(it);
      const compareTotal = info.compareAtCents * it.quantity;
      const priceTotal = it.final_line_price || it.line_price;
      const saveCents = compareTotal - priceTotal;
      const itemImage = it.image || giftAssets.product;
      const tierIdx = TIER_ORDER.indexOf(String(it.variant_id));
      const atMaxTier = tierIdx !== -1 && tierIdx === TIER_ORDER.length - 1;
      return `
      <div class="hp-cart-line">
        <div class="hp-cart-line__img">${itemImage ? `<img src="${itemImage}" alt="${it.title}">` : ''}</div>
        <div class="hp-cart-line__body">
          <div class="hp-cart-line__top-row">
            <p class="hp-cart-line__name">${it.product_title}</p>
            <div class="hp-cart-line__price-col">
              <div class="hp-cart-line__price-row">
                ${saveCents > 0 ? `<span class="hp-cart-line__compare">${money(compareTotal)}</span>` : ''}<span class="hp-cart-line__price">${money(priceTotal)}</span>
              </div>
              ${saveCents > 0 ? `<span class="hp-cart-line__save">Save ${money(saveCents)}</span>` : ''}
            </div>
          </div>
          <div class="hp-cart-line__bottom-row">
            <div class="hp-cart-line__qty">
              <button class="hp-qty-btn" data-key="${it.key}" data-variant-id="${it.variant_id}" data-qty="${it.quantity}" data-delta="-1">&minus;</button>
              <span>${info.pillows * it.quantity}</span>
              <button class="hp-qty-btn" data-key="${it.key}" data-variant-id="${it.variant_id}" data-qty="${it.quantity}" data-delta="1"${atMaxTier ? ' disabled' : ''}>+</button>
            </div>
            <button class="hp-cart-line__delete" data-key="${it.key}" data-delete aria-label="Remove item">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path><path d="M10 11v6"></path><path d="M14 11v6"></path><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path></svg>
            </button>
          </div>
        </div>
      </div>`;
    }).join('');

    /* Real gift lines — rendered from whatever gift variants are actually in
       the cart (added alongside the pillow in addToCart above), matched back
       to GIFTS for display copy/compare-at/image. Always rendered in GIFTS'
       canonical order (Half-Moon, then 90-Day) regardless of the order Shopify
       stored the lines in, so it's always Pillow → Half-Moon → 90-Day. */
    const giftLinesHtml = GIFTS.filter(g =>
      giftItemsInCart.some(it => String(it.variant_id) === g.variantId)
    ).map(g => `
      <div class="hp-cart-line">
        <div class="hp-cart-line__img"><img src="${g.image}" alt="${g.title}"></div>
        <div class="hp-cart-line__body">
          <div class="hp-cart-line__top-row">
            <div class="hp-cart-line__name-col">
              <p class="hp-cart-line__name">${g.title}</p>
              <span class="hp-gift-badge">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 12v9H4v-9"></path><path d="M2 7h20v5H2z"></path><path d="M12 22V7"></path><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path></svg>
                Free Gift
              </span>
            </div>
            <div class="hp-cart-line__price-col">
              <div class="hp-cart-line__price-row"><span class="hp-cart-line__compare">${money(g.compare)}</span><span class="hp-cart-line__price">FREE</span></div>
              <span class="hp-cart-line__save">Save ${money(g.compare)}</span>
              <div class="hp-gift-tag">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.59 13.41L11 3.83A2 2 0 0 0 9.59 3.24H4a1 1 0 0 0-1 1v5.59a2 2 0 0 0 .59 1.41l9.58 9.58a2 2 0 0 0 2.82 0l5.6-5.6a2 2 0 0 0 0-2.82z"></path><circle cx="7.5" cy="7.5" r="1.5"></circle></svg>
                ${totalPillows} PILLOW${totalPillows > 1 ? 'S' : ''}
              </div>
            </div>
          </div>
        </div>
      </div>`).join('');

    cartItems.innerHTML = realLinesHtml + giftLinesHtml;

    /* Totals: real items' compare/actual + gifts' compare (gifts cost $0 actual).
       The congrats banner mirrors the PDP's "Save $X" framing — it reflects only
       the product's own discount, not the value of the bundled free gifts. */
    const realCompareTotal = pillowItems.reduce((sum, it) => sum + bundleInfo(it).compareAtCents * it.quantity, 0);
    const realActualTotal  = pillowItems.reduce((sum, it) => sum + (it.final_line_price || it.line_price || 0), 0);
    const giftsCompareTotal = giftItemsInCart.reduce((sum, it) => {
      const g = GIFTS.find(g => g.variantId === String(it.variant_id));
      return sum + (g ? g.compare : 0);
    }, 0);

    const shippingCents = shippingToggle && shippingToggle.checked ? 495 : 0;
    const totalCompare = realCompareTotal + giftsCompareTotal;
    const totalActual  = realActualTotal + shippingCents;
    const totalSavings = realCompareTotal - realActualTotal;
    const totalItemCount = totalPillows + giftItemsInCart.length;

    cartCount && (cartCount.textContent = totalItemCount, cartCount.hidden = false);
    cartCountBadge && (cartCountBadge.textContent = totalItemCount);
    cartCongrats && (cartCongrats.hidden = false);
    cartSavingsAmt && (cartSavingsAmt.textContent = money(totalSavings));
    cartReserved && (cartReserved.hidden = false);
    cartShipProgress && (cartShipProgress.hidden = false);
    cartFoot && (cartFoot.hidden = false);
    cartItemCount && (cartItemCount.textContent = `Total: ${totalItemCount} Items`);
    cartTotalCompare && (cartTotalCompare.textContent = money(totalCompare));
    cartTotalPrice && (cartTotalPrice.textContent = money(totalActual));

    startReserveTimer();

    $$('.hp-qty-btn').forEach(b => b.addEventListener('click', e => {
      const btn = e.currentTarget;
      if (btn.disabled) return;
      const key = btn.dataset.key;
      const variantId = btn.dataset.variantId;
      const delta = parseInt(btn.dataset.delta, 10);
      const tierIdx = TIER_ORDER.indexOf(variantId);

      if (tierIdx === -1) {
        // Not a known bundle tier — fall back to plain quantity adjustment.
        const newQty = Math.max(0, parseInt(btn.dataset.qty, 10) + delta);
        updateQty(key, newQty);
        return;
      }

      const newTierIdx = tierIdx + delta;
      if (newTierIdx < 0) {
        removePillowAndGifts(key); // below the smallest pack — remove the line + gifts
      } else if (newTierIdx >= TIER_ORDER.length) {
        return; // already at the largest pack — nothing higher to switch to
      } else {
        switchVariant(key, TIER_ORDER[newTierIdx]);
      }
    }));
    $$('[data-delete]').forEach(b => b.addEventListener('click', e => {
      removePillowAndGifts(e.currentTarget.dataset.key);
    }));
  };

  shippingToggle?.addEventListener('change', () => fetchCart());

  fetchCart();

  $$('[data-hp-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', () => {
      const variantId = btn.getAttribute('data-variant-id');
      const qtyInput = document.getElementById(btn.getAttribute('data-qty-input'));
      const qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      if (!variantId) return;
      const originalText = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;
      addToCart(variantId, qty)
        .catch(err => alert(err.message))
        .finally(() => { btn.textContent = originalText; btn.disabled = false; });
    });
  });

  $('#hpQtyMinus')?.addEventListener('click', () => {
    const input = $('#hpQtyInput');
    if (input) input.value = Math.max(1, parseInt(input.value, 10) - 1);
  });
  $('#hpQtyPlus')?.addEventListener('click', () => {
    const input = $('#hpQtyInput');
    if (input) input.value = parseInt(input.value, 10) + 1;
  });
})();
